import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrap" }

import { env } from "@/utils"
import { Toast, Dialog, Skeleton as VanSkeleton } from "vant"
import { usePageStore } from "@/store"
import HomePage from "@/components/HomePage.vue"
import QuestionPage from "@/components/QuestionPage.vue"
import ResultPage from "@/components/ResultPage.vue"
import { onBeforeMount, ref } from "vue"
import { storeToRefs } from "pinia"
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/skeleton/style'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


const pageStateStore = usePageStore()
const pageStateStoreRefs = storeToRefs(pageStateStore)

const showSke = ref(true)

onBeforeMount(() => {
  const android = Reflect.get(window, "android");
  const webkit = Reflect.get(window, "webkit");

  // 显示活动说明
  function showInfo() {
    Dialog.alert({
      title: "问答说明",
      message: pageStateStore.$state.pageInfo.collect?.content?.replace(/<\/p>/g,"\r\n").replace(/<.+>/g,"")
    })
  }

  try {
    // 设置用户数据回调

    // APP用户体系
    Reflect.set(
        window,
        "getUserId",
        (data: { userid: string; imei: string } & string) => {
          if (pageStateStore.pageInfo.fields && pageStateStore.pageInfo.fields.length >0) {
            return
          }
          let _data = data;
          if (typeof data === "string") {
            _data = JSON.parse(data);
          }
          pageStateStore.$patch({
            userid: _data.userid,
            imei: _data.imei,
          });
          if (pageStateStore.userid === "0") {
            Toast("请先登录再填写");
          }
          pageStateStore.queryPageInfo().then(() => {
            showSke.value = false
            showInfo()
            pageStateStore.changePage(1)
          })
        }
    );

    if (!env().isNgzb) {
      Reflect.get(
          window,
          "getUserId"
      )({
        userid: "C391FBCA0063624244A630FE0746123C",
        imei: "353693505653247",
      });
    }
    // 主动触发获取用户信息
    if (webkit) {
      webkit.messageHandlers.openNative.postMessage(
          JSON.stringify({
            type: "nativeAction",
            nativeEventName: "getUserId",
            jsEventName: "getUserId",
          })
      );
    }

    // 安卓关闭滑屏
    android && android.slideCloseEnable("88");

    // 检查手机绑定状态
    if (android) {
      android.phoneStatus("");
    } else if (webkit) {
      webkit.messageHandlers.openNative.postMessage(
          JSON.stringify({
            type: "phoneStatus",
          })
      );
    }

    // 设置手机状态查询回调
    Reflect.set(
        window,
        "phoneStatus",
        (result: { status: string } & string) => {
          let _result = result;
          if (typeof _result === "string") {
            _result = JSON.parse(_result);
          }
          pageStateStore.$patch({
            bindPhone: _result.status,
          });
        }
    );
  } catch (err) {
    console.log(err);
  }
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_unref(VanSkeleton), { row: 10 }, null, 512), [
      [_vShow, showSke.value]
    ]),
    (_unref(pageStateStoreRefs).currPage.value === 1)
      ? (_openBlock(), _createBlock(HomePage, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(pageStateStoreRefs).currPage.value === 2)
      ? (_openBlock(), _createBlock(QuestionPage, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(pageStateStoreRefs).currPage.value === 3)
      ? (_openBlock(), _createBlock(ResultPage, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})